
import { defineComponent } from 'vue';
import Banner from '@/components/banner/Banner.vue';
import AddIcon from '@/components/icons/AddIcon.vue';
import DeleteIcon from '@/components/icons/DeleteIcon.vue';
import {
  getValidateCode,
  queryCountryList,
  addGuestFeedback
} from '@/api/apis';
// import { MinusOutlined, PlusOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { mapActions, mapState } from 'vuex';
import { baseFileUrl } from '@/utils/constants';
import { validateQuantity, validateLength } from '@/utils/validate';
import QuantityInput from '@/components/quantity-input/QuantityInput.vue';

export default defineComponent({
  name: 'ProductInquiry',
  components: {
    Banner,
    AddIcon,
    DeleteIcon,
    // MinusOutlined,
    // PlusOutlined
    QuantityInput
  },
  data() {
    return {
      validateQuantity,
      validateLength,
      loading: false,
      validateImg: null,
      form: {
        gender: 1,
        checkKey: 'key_' + (Math.floor(Math.random() * 10000) + 10000)
      },
      labelCol: { span: 7 },
      wrapperCol: { span: 17 },
      radioStyle1: {
        display: 'inline-block',
        height: '30px',
        lineHeight: '30px',
        marginRight: '40px'
      },
      radioStyle2: {
        display: 'inline-block',
        height: '30px',
        lineHeight: '30px'
      },
      countryList: [],
      smGuestFeedbackVehicle: new Array<any>(),
      columns: [
        {
          title: this.$t('product_inquiry.pi_items'),
          dataIndex: 'item',
          width: 140,
          slots: { customRender: 'photo' }
        },
        {
          title: this.$t('product_inquiry.pi_name'),
          dataIndex: 'name',
          width: 140,
          slots: { customRender: 'name' }
        },
        {
          title: this.$t('product_inquiry.pi_quantity'),
          dataIndex: 'quantity',
          width: 120,
          slots: { customRender: 'quantity' }
        },
        {
          title: '',
          width: 60,
          align: 'center',
          slots: { customRender: 'action' }
        }
      ]
    };
  },
  computed: {
    ...mapState(['inquireFormData', 'previousUrl'])
  },
  created() {
    this.restoreCacheData();
    this.getValidateCode();
    this.getCountryList();
  },
  methods: {
    ...mapActions(['setInquireFormData', 'clearInquireFormData']),
    async restoreCacheData() {
      if (this.inquireFormData) {
        this.form = this.inquireFormData.form;
        this.smGuestFeedbackVehicle =
          this.inquireFormData.smGuestFeedbackVehicle || [];
      }
      if (
        this.$route.params.id &&
        this.smGuestFeedbackVehicle.every(i => i.id !== this.$route.params.id)
      ) {
        this.smGuestFeedbackVehicle.push({
          ...this.$route.params,
          quantity: 1
        });
        this.cacheFormData();
      }
    },
    async getValidateCode() {
      const res = await getValidateCode(this.form.checkKey);
      if (res.success) {
        this.validateImg = res.result;
      }
    },
    async getCountryList() {
      const res = await queryCountryList();
      if (res.success) {
        this.countryList = res.result;
      }
    },
    getPreviewImg(showImg) {
      const images: string[] = (showImg || '').split(',');
      return images.length && images[0] ? `${baseFileUrl}${images[0]}` : '';
    },
    cacheFormData() {
      this.setInquireFormData({
        form: this.form,
        smGuestFeedbackVehicle: this.smGuestFeedbackVehicle
      });
    },
    handleRemoveVehicle(index) {
      this.smGuestFeedbackVehicle.splice(index, 1);
      this.cacheFormData();
    },
    handleContinueInquiry() {
      this.cacheFormData();
      if (this.previousUrl === '/products') {
        this.$router.back();
      } else {
        this.$router.push('/products');
      }
    },
    handleQuantityChange(value, record, index) {
      this.smGuestFeedbackVehicle.splice(index, 1, {
        ...record,
        quantity: value
      });
      this.cacheFormData();

      // set cache
    },
    handleInquiry() {
      (this.$refs as any).form
        .validate()
        .then(async () => {
          this.loading = true;
          const res = await addGuestFeedback({
            ...this.form,
            smGuestFeedbackVehicle: this.smGuestFeedbackVehicle.map(i => ({
              inquireVehicleId: i.id,
              inquireVehicleName: i.vehicleName,
              inquireVehicleNumber: i.quantity,
              modelNum: i.modelNum
            }))
          });
          if (res.success) {
            message.success(this.$t(res.message));
            this.clearInquireFormData();
            this.form = {
              gender: 1,
              checkKey: 'key_' + (Math.floor(Math.random() * 10000) + 10000)
            };
            this.smGuestFeedbackVehicle = [];
            this.getValidateCode();
          }
          this.loading = false;
        })
        .catch();
    }
  }
});
